import { accountLoad } from '../../../api/account'
import { WZ } from '../../../utils/wz.v2'
import { isString } from 'util'
import { isPlain } from '../../../utils/xp.v1'

async function loadAccount({ commit }, args) {
  const info = await accountLoad(args)
  commit('update', info)
  return info
}

async function readAccount({ state, dispatch }) {
  let { info } = state
  if (!!info && info.uid > 0) {
    return info
  }
  info = await dispatch('loadAccount')
  return info
}

async function loadMyUid({ dispatch }) {
  const info = await dispatch('loadAccount', {})
  return info && info.uid > 0 ? +info.uid : 0
}

async function readMyUid({ getters, dispatch }) {
  let { uid } = getters
  if (!uid) {
    uid = await dispatch('loadMyUid')
  }
  return uid > 0 ? +uid : 0
}

async function goLogin(_ctx, query) {
  query = isString(query)
    ? { redirectUrl: query }
    : isPlain(query)
    ? query
    : {}
  WZ.go('login', query)
}

async function goLogout(_ctx, query) {
  query = isString(query)
    ? { redirectUrl: query }
    : isPlain(query)
    ? query
    : {}
  WZ.go('logout', query)
}

export default {
  loadAccount,
  loadMyUid,
  readAccount,
  readMyUid,
  goLogin,
  goLogout
}
